import logEvent from "./log-event"

export const getSlideshowViewEventOptions = () => {
  const slideshow = window.slideshare_object.slideshow
  return {
    slideshow_id: slideshow.id,
    slideshow_created_at: slideshow.created_at,
    slideshow_category: slideshare_object.gam_cat_name,
    slideshow_language: slideshow.language,
    slideshow_format: slideshow.type,
    source: "slideshow_view",
  }
}

function logShareInteractedEvent(source) {
  const options = $.extend({}, getSlideshowViewEventOptions(), {
    social: source,
  })
  logEvent("slideshow_share_interacted", options)
}

export const logSlideshowViewed = ({ viewRestrictionState, viewRestrictionCounter }) => {
  const options = $.extend({}, getSlideshowViewEventOptions(), {
    slideshow_num_pages: window.slideshare_object.slideshow.total_slides,
    view_restriction_state: viewRestrictionState,
    view_restriction_counter: viewRestrictionCounter,
  })
  logEvent("slideshow_viewed", options)
}

const logRecommendationInteractionEvent = (event) => {
  const slideshow = window.slideshare_object.slideshow

  /**
   * recommendation_source value definitions:
   * item_similarity: populated by new algo
   * linkedIn: recommended by LinkedIn algo
   * homepage: featured on homepage
   * user: other slideshows uploaded by user
   * scribd: Scribd books + audiobooks
   * recommendation_type - slideshow, book, audiobook
   * recommendation_module_position - below, top-right
   **/
  const recEventOptions = {
    from_slideshow_id: slideshow.id,
    from_slideshow_created_at: slideshow.created_at,
    from_slideshow_category: slideshare_object.gam_cat_name,
    from_slideshow_language: slideshow.language,
    from_slideshow_format: slideshow.type,
    source: "slideshow_view",
    to_slideshow_id: event.currentTarget.dataset.ssid,
    recommendation_location: event.currentTarget.dataset.trackingId,
    recommendation_source: event.currentTarget.dataset.sourceName,
    recommendation_type: event.currentTarget.dataset.recommendationType,
    recommendation_module_position: event.currentTarget.dataset.recommendationModulePosition,
  }

  logEvent("slideshow_recommendation_click", recEventOptions)
}

const bindEventListeners = () => {
  $(".facebook .share-link").click(function () {
    logShareInteractedEvent("facebook")
  })

  $(".twitter .share-link").click(function () {
    logShareInteractedEvent("twitter")
  })

  $(".linkedin .share-link").click(function () {
    logShareInteractedEvent("linkedin")
  })

  $(".j-share-embed").click(function () {
    logShareInteractedEvent("embed")
  })

  $(".wordpress-container").click(function () {
    logShareInteractedEvent("wordpress")
  })

  $(".share-link-container").click(function () {
    logShareInteractedEvent("link")
  })

  $(".slideshow-action .share").click(function () {
    logEvent("slideshow_share_initiated", getSlideshowViewEventOptions())
  })

  $(".clip-button").click(function (e) {
    e.preventDefault()
    e.stopPropagation()
    logEvent("slideshow_clipped", getSlideshowViewEventOptions())
  })

  $("#mobile-clip-button").click(function () {
    logEvent("slideshow_clipped", getSlideshowViewEventOptions())
  })

  $(".clipping-indicator.top-clip").click(function () {
    logEvent("slideshow_jumped_to_clip", getSlideshowViewEventOptions())
  })

  $(".carousel-link").click(logRecommendationInteractionEvent)

  $(".j-related-impression").click(logRecommendationInteractionEvent)
}

export const initializeSlideshowEvents = () => {
  window.addEventListener("DOMContentLoaded", () => {
    bindEventListeners()
  })
}
